export class InsertGroup {
    groupName = ''//群名称
    headPortrait = ''//群头像
    managerId = ''//创建人用户名
    managerName = ''//创建人性名
    roomName = ''//群组唯一标识
    ksChatuserList: string[] = [];

    static of(o: any) {
        return Object.assign(new InsertGroup(), o);
    }
}
